module.exports = __webpack_public_path__ + "static/media/futsal.96cbe236.svg";